var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex_start flex_wrap" },
    _vm._l(_vm.list, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "flex_start flex_center_align item_box_s" },
        [
          _c("span", { staticClass: "sub_title" }, [
            _vm._v(_vm._s(item.title) + "："),
          ]),
          _vm._l(item.children, function (son, sonindex) {
            return _c(
              "div",
              {
                key: sonindex,
                staticClass: "sub_buttom flex_start flex_center_align",
                on: {
                  click: function ($event) {
                    return _vm.delet(item, sonindex, son.value, index)
                  },
                },
              },
              [
                _c("div", { staticClass: "name" }, [_vm._v(_vm._s(son.name))]),
                _vm._m(0, true),
              ]
            )
          }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "del_inner flex_center_align flex_center" },
      [
        _c("img", {
          attrs: { src: require("@/assets/images/close.png"), alt: "" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }